import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {CalendarDatePicker} from '@Components/calendar-date-picker';
import type {DateInputCalendarContentProps} from './date-input-calendar-content.types';

export function DateInputCalendarContent({minDate, maxDate, selectedDate, onDateSelected, isMobile = false}: DateInputCalendarContentProps): ReactElement<any> {
  return (
    <ClickableDiv
      className="flexbox"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <CalendarDatePicker minDate={minDate} maxDate={maxDate} selectedDate={selectedDate} onDateChange={onDateSelected} showBoxShadow={!isMobile} isFullWidth={isMobile} />
    </ClickableDiv>
  );
}
